<template>
  <v-dialog
    v-model="welcomeDialog"
    transition="dialog-top-transition"
    max-width="800"
    persistent
  >
    <v-card
      :class="$breakpoint.smAndDown ? 'px-6' : 'px-10'"
      class="py-6"
      light
    >
      <v-btn
        small
        icon
        fab
        absolute
        class="position-top"
        @click="$store.commit('home/SET_WELCOMEMODAL', false)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title class="primary--text pa-0 text-capitalize"
        >Welcome {{ userName }},</v-card-title
      >
      <v-card-text class="black--text pa-0 mb-4"
        >Welcome to fairplay.club, making money is only a few steps
        away.</v-card-text
      >
      <v-card-text class="black--text pa-0 mb-2 font-weight-bold"
        >Watch this quick video to understand the website</v-card-text
      >
      <div class="mb-4">
        <iframe
          v-if="welcomeDialog"
          class="video-iframes mr-4"
          src="https://www.youtube.com/embed/apU2xqAAaZA?autoplay=1&mute=1"
          allow="autoplay"
          frameborder="0"
          allowfullscreens
          height="300"
          width="100%"
          loading="lazy"
          title="fairplay video gallery"
        ></iframe>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    userName() {
      return this.$store.state.profile.data.name
    },
    welcomeDialog() {
      return this.$store.state.home.welcomeModal
    }
  }
}
</script>

<style></style>
